import { ComponentPropsWithoutRef } from 'react';
import { StyledTHead } from './styles';

export const THead = (props: ComponentPropsWithoutRef<'thead'>) => <StyledTHead {...props} />;
